<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import SaleService from '@/services/sale'

export default {
  page: {
    title: "Checkout",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, Multiselect },
  data() {
    return {
      title: "Checkout",
      loading: false,
      order: null,
      cart: {},
      carriers: [],
      paymentMethods: [],
      paymentConditions: [],
      checkout: {
        carrier: '',
        note: '',
        paymentMethod: '',
        paymentCondition: '',
        status: '',
      },
      checkoutPayment: ''
    };
  },
  mounted() {
    this.order = this.$store.getters.orderData;
    this.cart = this.order.cart;

    this.checkout.status = this.order.cart.status; 
    this.checkout.note = this.order.cart.note;
    this.checkout.paymentMethod = this.order.cart.paymentMethod;
    this.checkout.paymentCondition = this.order.cart.paymentCondition;

    let loader = this.$loading.show();

    const all = [
      SaleService.getCarriers(),
      SaleService.getPaymentMethods(),
      SaleService.getPaymentConditions(this.cart._id),
    ]

    Promise.all(all).then(res => {
      // load carriers
      this.carriers = res[0].data;

      const find = this.carriers.find(item => {
        return item._id === this.order.cart.carrier;
      })
      this.checkout.carrier = find;

      // load payment methods
      this.paymentMethods = res[1].data;
      this.checkout.paymentMethod = this.paymentMethods[0]._id;

      // load payment conditions
      this.paymentConditions = res[2].data;

      loader.hide();
    }).catch(() => {
      this.$toast.error('Erro ao carregar os dados do pedido')
      loader.hide();
    })
  },
  methods: {
    sendOrder() {
      if (!this.checkout.carrier) {
        return this.$toast.warning('Informe a transportadora');
      }

      if (!this.checkout.paymentCondition) {
        return this.$toast.warning('Informe a condição de pagamento');
      }

      this.$bvModal.show('modal-confirm');
    },
    updateCart() {
      const data = {
        note: this.checkout.note,
        carrier: this.checkout.carrier._id,
        paymentMethod: this.checkout.paymentMethod,
        paymentCondition: this.checkout.paymentCondition,
        status: this.checkout.status,
      }

      this.loading = true;
      this.$bvModal.hide('modal-confirm');

      SaleService.updateCart(this.order.cart._id, data).then(() => {
        if (data.status === 'order') {
          this.$store.dispatch('NEW_ACTIVITY', { customerId: this.order.cart.customer._id, customerName: this.order.cart.customer.name });
        }

        this.$store.dispatch('STOP_ORDER')
        this.$router.push({ name: 'dashboard' })

        this.loading = false;
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao atualizar enviar o pedido. Tente novamente.');
        this.loading = false;
      })
    },
    changePaymentCondition() {
      const data = {
        paymentCondition: this.checkout.paymentCondition,
      }

      this.loading = true;

      SaleService.recalculateCart(this.order.cart._id, data).then((res) => {
        this.order.cart = res.data;
        this.cart = res.data;

        this.$store.dispatch('SAVE_ORDER', this.order);

        this.loading = false;
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao atualizar atualizar o pedido. Tente novamente.');
        this.loading = false;
      })
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <!-- <div class="card-body col-6">
            <h4 class="card-title mb-2">Pagamento</h4>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck1" checked />
              <label class="custom-control-label" for="customCheck1">Orçamento</label>
            </div>
          </div> -->

          <div class="card-body col-6">
            <div class="row">
              <div class="col-xl-4 col-sm-4">
                <label class="card-radio-label">
                  <input
                    type="radio"
                    name="pay-method"
                    id="pay-methodoption1"
                    class="card-radio-input"
                    v-model="checkout.status"
                    value="sale"
                  />
                  <div class="card-radio">
                    <span>ORÇAMENTO</span>
                  </div>
                </label>
              </div>

              <div class="col-xl-4 col-sm-4">
                <label class="card-radio-label">
                  <input
                    type="radio"
                    name="pay-method"
                    id="pay-methodoption2"
                    class="card-radio-input"
                    v-model="checkout.status"
                    value="order"
                  />
                  <div class="card-radio">
                    <span>PEDIDO</span>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div class="card-body col-lg-6 col-sm-12">
            <h4 class="card-title mb-2">Observação</h4>
            <textarea
              v-model="checkout.note"
              class="form-control"
              :maxlength="200"
              rows="3"
              placeholder="Se necessário, adicione alguma informação sobre o pedido"
            ></textarea>
            <div class="text-left">
              <p
                v-if="checkout.note"
                class="badge position-absolute"
                :class="{ 'badge-primary': checkout.note.length !== 200,
                          'badge-danger': checkout.note.length === 200 }"
              >
                {{ checkout.note.length }} /
                200
              </p>
            </div>
          </div>

          <div class="card-body col-6">
            <h4 class="card-title mb-2">Transportadora</h4>
            <multiselect
              v-model="checkout.carrier"
              :options="carriers"
              placeholder="Selecione uma opção"
              label="description"
              track-by="_id"
              selectLabel="Enter para selecionar"
              selectedLabel="Selecionado"
              deselectLabel="Enter para remover"
            ></multiselect>
          </div>

          <div class="card-body col-6">
            <h4 class="card-title mb-4">Formas de Pagamento</h4>

            <div class="custom-control custom-radio">
              <div v-for="payment of paymentMethods" :key="payment._id" class="mb-2">
                <input type="radio" :value="payment._id" :name="payment._id" :id="payment._id" class="custom-control-input" v-model="checkout.paymentMethod" />
                <label class="custom-control-label" :for="payment._id">{{payment.description}}</label>
              </div>
            </div>
          </div>

          <div class="card-body col-6" v-if="checkout.paymentMethod">
            <h4 class="card-title mb-4">Condição de Pagamento</h4>

            <div class="custom-control custom-radio">
              <div v-for="payment of paymentConditions" :key="payment._id" class="mb-2">
                <input type="radio" :value="payment._id" :name="payment._id" :id="payment._id" class="custom-control-input" v-model="checkout.paymentCondition" v-on:change="changePaymentCondition" />
                <label class="custom-control-label" :for="payment._id">{{payment.fullDescription}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-4">
        <router-link
          tag="a"
          to="/cart"
        >
          <button type="button" size="lg" class="btn btn-info btn-block btn-outline">
            <i class="bx bx-left-arrow-alt font-size-16 align-middle mr-2"></i>Voltar para o Carrinho
          </button>
        </router-link>
      </div>

      <div class="col-4 align-items-center text-center">
        <div v-if="cart.totalDiscounts" class="inline">
          <p class="mb-0 font-size-11 mr-1">Total de Produtos: </p>
          <h4 class="card-title mb-0">R$ {{(cart.total + cart.totalDiscounts) | currency}}</h4>
        </div>
        
        <div v-if="cart.totalDiscounts" class="inline">
          <p class="mb-0 font-size-11 mr-1">Você economizou: </p>
          <h4 class="card-title mb-0">R$ {{cart.totalDiscounts | currency}}</h4>
        </div>

        <div class="inline mt-2">
          <p class="mb-0 font-size-11 mr-1">Valor Total: </p>
          <h2 class="card-title font-size-20 mb-0">R$ {{cart.total | currency}}</h2>
        </div>
      </div>

      <div class="col-4 span-4 text-center">
        <!-- <router-link
          tag="a"
          to="/payment"
        > -->
          <button type="button" size="lg" class="btn btn-primary btn-outline btn-block" @click="sendOrder" v-if="!loading">
            Enviar {{checkout.status === 'sale' ? 'Orçamento' : 'Pedido'}}<i class="bx bx-check font-size-16 align-middle ml-2"></i>
          </button>

          <a href="javascript:void(0);" class="text-primary text-right" v-if="loading">
            <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
          </a>
        <!-- </router-link> -->
      </div>
    </div>

    <b-modal
      id="modal-confirm"
      title="Confirmação"
      title-class="font-18"
      centered
    >
      <p>Tem certeza que deseja enviar o pedido agora?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm')" class="mr-2">Cancelar</b-btn>
        <b-btn variant="primary" @click="updateCart">Confirmar</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .custom-control-label {
    font-weight: normal;
    font-weight: 12px;
  }

  .inline {
    display: flex;
    text-align: center;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
</style>